export const PATH = {
  DEFAULT: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  FORGOT_PASSWORD: "/forgot-password",
  REGISTER: "/register",
  OTP_VERIFICATION: "/otp-verification",
  CONFIRM_PASSWORD: "/confirm-password",
  SET_PASSWORD: "/set-password",
  INVITATION: "/invitation",
  PROJECT_PLANNING: "/project",
  BACKLOG: "/project/:projectId/backlog",
  SUMMARY: "/project/:projectId/summary",
  ISSUES: "/project/:projectId/issues",
  ACTIVE_SPRINT: "/project/:projectId/active-sprint",
  ACTIVE_SPRINT_DETAILS: "/project/:projectId/issue/:issueId",
  DEVELOPMENT: "/development",
  CODE: "/development/code",
  PROJECTS: "/projects",
  CREATE_PROJECTS: "/projects/create-projects",
  PROJECT_SETTINGS: "/project/:projectId/project-details/project-settings",
  PROJECT_DETAILS: "/project/:projectId/project-details",
  PROJECT_COMPONENT: "/project/:projectId/project-details/project-component",
  TIMELINE_SETTINGS: "/project/:projectId/timeline-settings",
  MEMBER_SETTINGS: "/project/:projectId/member-settings",
  VIEW_WORKFLOW: "/project/:projectId/workflow",
  RELEASES: "/project/:projectId/releases",
  PROFILE_VIEWPROFILE: "/profile-viewprofile",
  SUPPORT_PROFILE_VIEWPROFILE: "/supportdesk/profile-viewprofile",
  PROJECT_ALL_MEMBER:"/projects/members",
  SETTINGS: "/settings",
  ROLES: "/settings/roles",
  TEAMS: "/teams",
  VIEW_ALL_ISSUSES: "/projects/filter/view-all-issues",
  ERRORPAGE: "/errorPage",
  DUEDATEREQUEST: "/duedate-approval-request",
  CUSTOMERS:"/project/:projectId/customers",
  ADMIN:"/admin",
  USER_MANAGEMENT: "/project/:projectId/user-management",
  USER_MANAGEMENT_ROLES: "/project/:projectId/user-management/roles",
  GLOBAL_USER_MANAGEMENT: "/projects/user-management/roles",
  USER_LIST: "/projects/user-management/getallusers",

  // support portal
  SUPPORT_PORTAL:"/supportdesk",
  TECHNICAL_SUPPORT:'/technical-support',
  SUPPORT_ISSUE_DETAILS:'/customer/requests/issue/:issueId',
  TEST_Case:'/project/:projectId/test-cases',
  TEST_CASE_IMPORT_LOGS:'/project/:projectId/test-cases/import-logs',
  TEST_RUN:'/project/:projectId/test-runs',
  TEST_RUN_DETAILS:'/project/:projectId/test-runs/:runId',
  TEST_RUN_CASE_DETAILS:'/project/:projectId/test-runs/:runId/test-cases/:testCaseId',
  // SUPPORT_REQUESTS:'/support-requests',
  CUSTOMIZE_DSR: "/customize-dsr",
  TIMESHEET: "/timesheet",
};
